Bingo.HelpPopup = {};
Bingo.HelpPopup.mapDraw = {};

Bingo.HelpPopup.init = function () {
    $('.js-helpPopupTrigger').click(function () {
        Bingo.HelpPopup.openByUrl($(this).attr('data-url'));
        this.blur();
    });
};

Bingo.HelpPopup.mapDraw.init = function () {
    new Swiper('.js-helpPopup__mapDraw', {
        allowTouchMove: true,
        loop: false,
        observer: true,
        navigation: {
            nextEl: '.js-helpPopup__mapDraw-next',
            prevEl: '.js-helpPopup__mapDraw-prev',
        },
        spaceBetween: 15,
        speed: 850,
        slidesPerView: 1,
        breakpoints: {
            576: {
                allowTouchMove: false,
                slidesPerView: 2,
            },
        },
        on: {
            init() {
                // Fix swiper in fluid fancybox container
                const that = this;
                setTimeout(() => {
                    that.update();
                }, 100);
            },
        },
    });
    $('.js-helpPopup__mapDraw-close').click(function () {
        const $url = $(this).attr('data-url');
        $.fancybox.close();
        $.nette.ajax({
            type: 'POST',
            url: $url,
        });
    });
};

Bingo.HelpPopup.openByUrl = function ($url) {
    $.nette.ajax({url: $url}).success((data) => {
        $.fancybox.open(data, {
            modal: true,
            infobar: false,
            animationEffect: 'zoom-in-out',
        });
    });
};
